[
  {
    "id": "TB-M7-001",
    "module": "Taalbegrip",
    "difficulty": 203,
    "question": "Tik op het stuk tekst waar 'hierdoor' naar verwijst.",
    "options": ["boeken snel en goedkoop gedrukt konden worden"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "De uitvinding van de boekdrukkunst veranderde de wereld. Voorheen werden ", "id": "s1", "isTappable": false },
        { "text": "boeken met de hand overgeschreven", "id": "s2" },
        { "text": ". Dat duurde maanden. Dankzij Gutenberg konden ", "id": "s3", "isTappable": false },
        { "text": "boeken snel en goedkoop gedrukt worden", "id": "s4", "isCorrect": true },
        { "text": ". ", "id": "s5", "isTappable": false },
        { "text": "Hierdoor", "id": "s6", "isHighlighted": true, "isTappable": false },
        { "text": " konden ", "id": "s7", "isTappable": false },
        { "text": "meer mensen leren lezen", "id": "s8" },
        { "text": ".", "id": "s9", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "Dat was juist het probleem dat opgelost werd, niet de oorzaak.",
        "s4": "Goed! 'Hierdoor' verwijst naar het snel en goedkoop drukken. Dat was de oorzaak dat meer mensen konden lezen.",
        "s8": "Dat is juist het gevolg, niet de oorzaak."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-GUTENBERG",
    "explanation": "'Hierdoor' verwijst naar de vorige zin: boeken konden snel en goedkoop gedrukt worden. Dat was de oorzaak dat meer mensen konden lezen.",
    "distractorExplanations": {
      "1": "Dat was juist het probleem dat opgelost werd.",
      "7": "Dat is juist het gevolg, niet de oorzaak."
    }
  },
  {
    "id": "TB-M7-002",
    "module": "Taalbegrip",
    "difficulty": 203,
    "question": "Welk signaalwoord past het best?\n\n\"De film kreeg slechte recensies. ... gingen er veel mensen naartoe.\"",
    "options": ["Desondanks", "Daarom", "Bovendien", "Vervolgens"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-DESONDANKS",
    "explanation": "'Desondanks' geeft een tegenstelling aan: ondanks de slechte recensies gingen er toch veel mensen. Je zou verwachten dat niemand gaat, maar het tegenovergestelde gebeurt.",
    "distractorExplanations": {
      "1": "'Daarom' zou betekenen dat ze VANWEGE de slechte recensies gingen, wat onlogisch is.",
      "2": "'Bovendien' voegt iets toe, maar hier is sprake van een tegenstelling.",
      "3": "'Vervolgens' geeft tijdsvolgorde aan, niet een tegenstelling."
    }
  },
  {
    "id": "TB-M7-003",
    "module": "Taalbegrip",
    "difficulty": 203,
    "question": "Tik op het stuk tekst waar 'dit signaal' naar verwijst.",
    "options": ["een chemisch signaal"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "Wetenschappers hebben ontdekt dat planten kunnen 'communiceren'. Wanneer een boom wordt aangevallen door ", "id": "s1", "isTappable": false },
        { "text": "insecten", "id": "s2" },
        { "text": ", geeft hij ", "id": "s3", "isTappable": false },
        { "text": "een chemisch signaal", "id": "s4", "isCorrect": true },
        { "text": " af. Bomen in de buurt ontvangen ", "id": "s5", "isTappable": false },
        { "text": "dit signaal", "id": "s6", "isHighlighted": true, "isTappable": false },
        { "text": " en maken extra ", "id": "s7", "isTappable": false },
        { "text": "verdedigingsstoffen", "id": "s8" },
        { "text": " aan.", "id": "s9", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "De insecten vallen aan, ze geven geen signaal af.",
        "s4": "Goed! 'Dit signaal' verwijst terug naar 'een chemisch signaal' uit de vorige zin.",
        "s8": "Verdedigingsstoffen zijn het gevolg, niet het signaal."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-BOMEN",
    "explanation": "'Dit signaal' verwijst terug naar 'een chemisch signaal' uit de vorige zin.",
    "distractorExplanations": {
      "1": "De insecten vallen aan, ze geven geen signaal af.",
      "7": "Verdedigingsstoffen zijn het gevolg, niet het signaal."
    }
  },
  {
    "id": "TB-M7-004",
    "module": "Taalbegrip",
    "difficulty": 203,
    "question": "Lees de tekst:\n\n\"Steeds meer scholen verbieden smartphones in de klas. Enerzijds leidt het af van de les. Anderzijds kan een telefoon ook nuttig zijn als leermiddel.\"\n\nWat voor signaalwoorden zijn 'enerzijds' en 'anderzijds'?",
    "options": ["Ze geven twee kanten van een zaak aan (voor- en nadeel)", "Ze geven een tijdsvolgorde aan", "Ze geven een opsomming aan", "Ze geven een oorzaak aan"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-ENERZIJDS",
    "explanation": "'Enerzijds... anderzijds' presenteert twee kanten: een nadeel (afleiding) en een voordeel (leermiddel).",
    "distractorExplanations": {
      "1": "Er is geen tijdsvolgorde; beide punten bestaan tegelijk.",
      "2": "Het is geen opsomming van gelijke punten, maar een afweging.",
      "3": "Er wordt geen oorzaak-gevolg relatie gelegd."
    }
  },
  {
    "id": "TB-M7-005",
    "module": "Taalbegrip",
    "difficulty": 203,
    "question": "Lees de tekst:\n\n\"De Titanic was het grootste schip ter wereld. Men dacht dat het onzinkbaar was. Toch zonk het schip tijdens zijn eerste reis nadat het een ijsberg raakte.\"\n\nWat betekent het woord 'onzinkbaar'?",
    "options": ["Kan niet zinken", "Heel groot", "Heel snel", "Heel duur"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-ONZINKBAAR",
    "explanation": "'On-' betekent 'niet' en '-baar' betekent 'in staat om te'. Onzinkbaar = niet in staat om te zinken.",
    "distractorExplanations": {
      "1": "Groot wordt apart genoemd in de eerste zin.",
      "2": "Snelheid wordt niet besproken.",
      "3": "Kosten worden niet besproken."
    }
  },
  {
    "id": "TB-M7-006",
    "module": "Taalbegrip",
    "difficulty": 203,
    "question": "Lees de tekst:\n\n\"Haaien hebben een slechte reputatie. Films zoals Jaws maken mensen bang. In werkelijkheid vallen haaien zelden mensen aan. Muggen zijn veel gevaarlijker: zij doden jaarlijks honderdduizenden mensen.\"\n\nWat wil de schrijver duidelijk maken?",
    "options": ["Dat haaien minder gevaarlijk zijn dan mensen denken", "Dat films altijd de waarheid vertellen", "Dat muggen schattige dieren zijn", "Dat je nooit moet zwemmen"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "doel_schrijver",
    "familyId": "TB-HAAIEN-DOEL",
    "explanation": "De schrijver contrasteert het beeld uit films ('slechte reputatie') met de werkelijkheid ('zelden aanvallen') en vergelijkt met muggen om te laten zien dat haaien minder gevaarlijk zijn.",
    "distractorExplanations": {
      "1": "De tekst zegt juist dat films een verkeerd beeld geven.",
      "2": "De tekst noemt muggen gevaarlijk, niet schattig.",
      "3": "De tekst gaat niet over zwemverboden."
    }
  },
  {
    "id": "TB-M7-007",
    "module": "Taalbegrip",
    "difficulty": 203,
    "question": "Wat betekent het woord 'figuurlijk' in de zin: 'Hij barstte figuurlijk uit zijn vel van woede.'",
    "options": ["Niet letterlijk bedoeld, als beeldspraak", "Precies zoals het er staat", "Met figuren erbij", "Op een grappige manier"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-WOORD-FIGUURLIJK",
    "explanation": "'Figuurlijk' betekent dat je het niet letterlijk moet nemen. Hij barstte niet echt uit zijn vel, maar was heel erg boos.",
    "distractorExplanations": {
      "1": "Letterlijk zou betekenen dat zijn vel echt scheurde.",
      "2": "Figuurlijk heeft niets met figuren/plaatjes te maken.",
      "3": "Het hoeft niet grappig te zijn."
    }
  },
  {
    "id": "TB-M7-008",
    "module": "Taalbegrip",
    "difficulty": 203,
    "question": "Lees de tekst:\n\n\"Eerst werd de aardappel in Zuid-Amerika verbouwd. Daarna brachten Spaanse ontdekkingsreizigers hem naar Europa. Uiteindelijk werd de aardappel een van de belangrijkste voedingsmiddelen ter wereld.\"\n\nWelke signaalwoorden geven de tijdsvolgorde aan?",
    "options": ["Eerst, daarna, uiteindelijk", "Werd, brachten, werd", "In, naar, van", "De, een, de"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-TIJD",
    "explanation": "'Eerst', 'daarna' en 'uiteindelijk' zijn signaalwoorden die de tijdsvolgorde aangeven.",
    "distractorExplanations": {
      "1": "Dit zijn werkwoorden, geen signaalwoorden.",
      "2": "Dit zijn voorzetsels.",
      "3": "Dit zijn lidwoorden."
    }
  },
  {
    "id": "TB-M7-009",
    "module": "Taalbegrip",
    "difficulty": 203,
    "question": "Tik op het stuk tekst waar 'dat' naar verwijst in de tweede zin.",
    "options": ["kamelen water opslaan in hun bulten"],
    "correctAnswer": 0,
    "questionType": "text_highlight",
    "interactiveConfig": {
      "segments": [
        { "text": "Veel mensen denken dat ", "id": "s1", "isTappable": false },
        { "text": "kamelen water opslaan in hun bulten", "id": "s2", "isCorrect": true },
        { "text": ". ", "id": "s3", "isTappable": false },
        { "text": "Dat", "id": "s4", "isHighlighted": true, "isTappable": false },
        { "text": " klopt niet. De bulten bevatten ", "id": "s5", "isTappable": false },
        { "text": "vet", "id": "s6" },
        { "text": ". Dit vet geeft energie wanneer er geen ", "id": "s7", "isTappable": false },
        { "text": "voedsel", "id": "s8" },
        { "text": " beschikbaar is.", "id": "s9", "isTappable": false }
      ],
      "feedbackMap": {
        "s2": "Goed! 'Dat klopt niet' verwijst naar de bewering dat kamelen water opslaan in hun bulten.",
        "s6": "Vet is wat de bulten echt bevatten, niet waar 'dat' naar verwijst.",
        "s8": "Voedsel wordt pas later in de tekst genoemd."
      }
    },
    "skill": "verbanden",
    "subSkill": "verwijswoorden",
    "familyId": "TB-VERWIJS-KAMEEL",
    "explanation": "'Dat klopt niet' verwijst naar de bewering in de eerste zin: dat kamelen water opslaan in hun bulten.",
    "distractorExplanations": {
      "5": "Vet is wat de bulten echt bevatten, niet waar 'dat' naar verwijst.",
      "7": "Voedsel wordt pas later in de tekst genoemd."
    }
  },
  {
    "id": "TB-M7-010",
    "module": "Taalbegrip",
    "difficulty": 203,
    "question": "Lees de tekst:\n\n\"Hoewel Nederland een klein land is, staat het op de tweede plaats als voedselexporteur. Alleen de Verenigde Staten exporteren meer. Dit komt onder andere door de moderne landbouwtechnologie.\"\n\nHet woord 'hoewel' geeft aan dat er een ... volgt.",
    "options": ["Tegenstelling (je verwacht het niet)", "Opsomming", "Voorbeeld", "Tijdsvolgorde"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "signaalwoorden",
    "familyId": "TB-SIGNAAL-HOEWEL",
    "explanation": "'Hoewel' geeft een tegenstelling aan: je zou niet verwachten dat een klein land zoveel exporteert.",
    "distractorExplanations": {
      "1": "Er worden geen gelijke punten opgesomd.",
      "2": "Er volgt geen voorbeeld, maar een verrassend feit.",
      "3": "Er is geen tijdsvolgorde."
    }
  }
]